<template>
    <div>
        <el-button size="mini" type="primary" @click="$refs.payCreate.Open({ model: 'ims_product_back', model_id: id })" >新建回款</el-button>
        <vxe-table border ref="xTable" :data="table" :loading="loading" :style="{ marginTop: '10px' }">
            <vxe-column width="90" title="审批状态" align="center">
                <template #default="{ row }">
                    <el-tag v-if="row.workflow_state == 0" size="mini" effect="dark" type="info">不需要审批</el-tag>
                    <el-tag v-if="row.workflow_state == 1" size="mini" effect="dark" type="warning">待审核</el-tag>
                    <el-tag v-if="row.workflow_state == 2" size="mini" effect="dark" >审核中</el-tag>
                    <el-tag v-if="row.workflow_state == 3" size="mini" effect="dark" type="danger">已拒绝</el-tag>
                    <el-tag v-if="row.workflow_state == 4" size="mini" effect="dark" type="success">已通过</el-tag>
                    <el-tag v-if="row.workflow_state == 5" size="mini" effect="dark" type="warning">待撤销</el-tag>
                    <el-tag v-if="row.workflow_state == 6" size="mini" effect="dark" type="warning">撤销中</el-tag>
                    <el-tag v-if="row.workflow_state == 7" size="mini" effect="dark" type="danger">撤销失败</el-tag>
                    <el-tag v-if="row.workflow_state == 8" size="mini" effect="dark" type="danger">已撤销</el-tag>
                </template>
            </vxe-column>
            <vxe-column min-width="120" field="number" title="回款编号">
                <template #default="{ row }">
                    <span class="el-span-primary" @click="$refs.payDrawer.Open(row.id)">{{ row.number }}</span>
                </template>
            </vxe-column>
            <vxe-column min-width="80" field="money" title="回款金额"></vxe-column>
            <vxe-column min-width="80" field="date" title="回款日期"></vxe-column>
            <vxe-column min-width="80" field="type.name" title="回款方式"></vxe-column>
            <vxe-column min-width="90" field="describe" title="回款备注"></vxe-column>
            <vxe-column min-width="90" field="created_user.name" title="创建人"></vxe-column>
            <vxe-column min-width="140" field="created_at" title="创建时间"></vxe-column>
        </vxe-table>
        <ims-pay-create ref="payCreate" @onChange="TableSearch" />
        <ims-pay-drawer ref="payDrawer" @onChange="TableSearch" />
    </div>
</template>
<script>
export default {
    props: {
        id: {
            type: Number,
            default: null
        },
    },
    data() {
        return {
            loading: false,
            table: [],
        }
    },
    watch: {
        id: {
            handler(val) {
                this.TableSearch()
            },
            immediate: true
        }
    },
    methods: {
                TableSearch() {
            this.loading = true
            this.$http.post('/9api/ims/pay/search-all', { search: { model: 'ims_product_back' , model_id: this.id }, append: ['created_user', 'type'] }).then(rps => {
                this.table = rps.data
                this.loading = false
            })
        },
    }
}
</script>